import image1 from "./image1.png";
import image2 from "./image2.png";
import image3 from "./image3.png";
import image4 from "./image4.png";
import image5 from "./image5.png";
import image6 from "./image6.png";
import image7 from "./image7.png";
import image8 from "./image8.png";
import image9 from "./image9.png";
import image10 from "./image10.png";
import image11 from "./image11.png";
import image12 from "./image12.png";
import image13 from "./image13.png";
import image14 from "./image14.png";
import image15 from "./image15.png";
import image16 from "./image16.png";
import image17 from "./image17.png";
import image18 from "./image18.png";

export const backgroundOptions = [
  image4,
  image3,
  image5,
  image6,
  image1,
  image2,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
  image13,
  image14,
  image15,
  image16,
  image17,
  image18,
];
